import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import AI_CREATE_PROMPT_REPORT from '../mutations/AI_CREATE_PROMPT_REPORT';

const useAICreatePromptReport = () => {
    const [ createNewPromptReport ] = useMutation( AI_CREATE_PROMPT_REPORT );

    const createPromptReport = async ( promptId ) => {
        try {
            const response = await createNewPromptReport( { variables: { input: { promptId } } } );
            const success = response?.data?.promptReport;

            if ( success ) {
                return {
                    success: true,
                    response
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error creating prompt report', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            createPromptReport         
        };
    }, [] );
};

export default useAICreatePromptReport;
